import { BaseIdNotRequiredRequest } from "../../../../base/request/BaseIdNotRequiredRequest";
import { toISODate } from "../../../../utils/fechaUtils";
import { RotacionPesajeVeterinariaResponse } from "../response/RotacionPesajeVeterinariaResponse";

/** Request de creación/edición de un evento de Pesaje / Rotación / Veterinaria
 *  (`POST .../save`). `id` null = crear, con valor = editar. Los datos de cada
 *  acción solo viajan si su flag está activo; los ids/valores no aplicables van
 *  `null` (nunca `""`). Se crea con las factories `fx_create…`. */
export type RotacionPesajeVeterinariaRequest = BaseIdNotRequiredRequest & {
  /** Id del potrero origen del evento. */
  loteOrigenId: string;
  /** Id del potrero destino (solo rotación; null si no aplica). */
  loteDestinoId: string | null;
  /** Fecha del evento (ISO). */
  fecha: string;
  /** Cantidad de animales involucrados. */
  cantidadAnimales: number;
  /** El evento incluye rotación de potrero. */
  isRotacion: boolean;
  /** El evento incluye pesaje. */
  isPesaje: boolean;
  /** El evento incluye procedimientos veterinarios. */
  isVeterinaria: boolean;
  /** Pesos individuales de cada animal (kg; solo pesaje). El server deriva
   *  mín/prom/máx/total de este array. */
  pesosAnimales: number[];
  /** Ids de los procedimientos veterinarios aplicados (solo veterinaria). */
  procedimientoIds: string[];
  /** Observaciones veterinarias (null si no aplica). */
  vetObservaciones: string | null;
};

export const fx_createRotacionPesajeVeterinariaRequestEmpty =
  (): RotacionPesajeVeterinariaRequest => {
    return {
      id: null,
      loteOrigenId: "",
      loteDestinoId: null,
      fecha: toISODate(new Date()),
      cantidadAnimales: 0,
      isRotacion: false,
      isPesaje: false,
      isVeterinaria: false,
      pesosAnimales: [],
      procedimientoIds: [],
      vetObservaciones: null,
    };
  };

export const fx_createRotacionPesajeVeterinariaRequest = (
  response: RotacionPesajeVeterinariaResponse,
): RotacionPesajeVeterinariaRequest => {
  return {
    id: response.id,
    loteOrigenId: response.loteOrigenId,
    loteDestinoId: response.loteDestinoId,
    fecha: response.fecha,
    cantidadAnimales: response.cantidadAnimales,
    isRotacion: response.isRotacion,
    isPesaje: response.isPesaje,
    isVeterinaria: response.isVeterinaria,
    pesosAnimales: [...response.pesosAnimales],
    procedimientoIds: [...response.procedimientoIds],
    vetObservaciones: response.vetObservaciones,
  };
};
